import { Http } from '@/http/http';
import {
  USER_ERROR,
  USER_REQUEST,
  USER_SUCCESS,
  FETCH_USER_CONTACTS_ERROR,
  FETCH_USER_CONTACTS_REQUEST,
  FETCH_USER_CONTACTS_SUCCESS,
  ADD_EVENT_SELECTED_CONTACTS_REQUEST,
  ADD_EVENT_SELECTED_CONTACTS_SUCCESS,
  ADD_EVENT_SELECTED_CONTACTS_ERROR,
  DELETE_EVENT_SELECTED_CONTACTS_REQUEST,
  DELETE_EVENT_SELECTED_CONTACTS_SUCCESS,
  DELETE_EVENT_SELECTED_CONTACTS_ERROR,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  SEARCH_CONTACT_REQUEST,
  SEARCH_CONTACT_SUCCESS,
  SEARCH_CONTACT_UNREGISTERED,
  SEARCH_CONTACT_ERROR,
  ADD_USER_CONTACT_REQUEST,
  ADD_USER_CONTACT_SUCCESS,
  ADD_USER_CONTACT_ERROR,
  CREATE_USER_CONTACT_ERROR,
  CREATE_USER_CONTACT_REQUEST,
  CREATE_USER_CONTACT_SUCCESS,
  DELETE_USER_CONTACT_REQUEST,
  DELETE_USER_CONTACT_SUCCESS,
  DELETE_USER_CONTACT_ERROR,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_ERROR,
} from './types';
import {
  DELETE_PAYOUT_USER,
  SET_EVENTS_CURRENCY,
  SET_PAYOUTS_ACTIVE_USER,
  UPDATE_USER_PAYOUTS,
} from '../events/types';

const getUser = async ({ commit }) => {
  try {
    commit(USER_REQUEST);
    const response = await Http.get('/user/me/');
    // .then((response) => {
    if (!response.user) {
      throw new URIError('Invalid credentials');
    }
    commit(SET_EVENTS_CURRENCY, response.currency);
    commit(USER_SUCCESS, response);
    // })
    // .catch(() => {
    // commit(USER_ERROR);
    // dispatch(AUTH_LOGOUT);
    // });
    return response.user;
  } catch (e) {
    commit(USER_ERROR);
    return Promise.reject(e);
  }
};

const updateUser = async ({ commit }, data) => {
  try {
    commit(UPDATE_USER_REQUEST);
    const res = await Http.put('/user/me/', data);
    commit(SET_EVENTS_CURRENCY, res.currency);
    commit(UPDATE_USER_SUCCESS, res);
  } catch (e) {
    commit(UPDATE_USER_ERROR);
  }
};

const changePassword = async ({ commit }, data) => {
  try {
    commit(CHANGE_PASSWORD_REQUEST);
    await Http.put('/v2/user/me/', data);
    commit(CHANGE_PASSWORD_SUCCESS);
  } catch (e) {
    commit(CHANGE_PASSWORD_ERROR, e);
    throw e;
  }
};

const getContacts = async ({ commit }) => {
  try {
    commit(FETCH_USER_CONTACTS_REQUEST);
    const res = await Http.get('/user/contacts/');
    commit(FETCH_USER_CONTACTS_SUCCESS, res);
    return Promise.resolve();
  } catch (e) {
    commit(FETCH_USER_CONTACTS_ERROR, e);
    return Promise.reject(e);
  }
};

const searchContact = async ({ commit }, data) => {
  try {
    const { phone } = data;
    const searchAll = !!data.searchAll;
    commit(SEARCH_CONTACT_REQUEST);
    const res = await Http.get(`/user/search/?phone=${phone}&search_all=${searchAll}`);
    res.phone = phone;
    commit(res.registration_date ? SEARCH_CONTACT_SUCCESS : SEARCH_CONTACT_UNREGISTERED, res);
  } catch (e) {
    commit(SEARCH_CONTACT_ERROR, e);
  }
};

const addUserContact = async ({ commit }, { contact }) => {
  try {
    commit(ADD_USER_CONTACT_REQUEST);
    const res = await Http.post('/user/contacts/', { device: 'WEB', contacts: [contact] });
    commit(ADD_USER_CONTACT_SUCCESS, res);
    commit(UPDATE_USER_PAYOUTS, res);
    commit(SET_PAYOUTS_ACTIVE_USER, res.find((elem) => elem.phone === contact.phone));
    return res;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('error in adding contact: ', e.message);
    commit(ADD_USER_CONTACT_ERROR, e.message);
    return null;
  }
};

const createUserContact = async ({ commit }, { contact }) => {
  try {
    commit(CREATE_USER_CONTACT_REQUEST);
    const res = await Http.post('/user/contacts/', { device: 'WEB', contacts: [contact] });
    commit(CREATE_USER_CONTACT_SUCCESS, res);
    commit(UPDATE_USER_PAYOUTS, res);
    commit(SET_PAYOUTS_ACTIVE_USER, res.find((elem) => elem.phone === contact.phone));
    return res;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('error in creating contact: ', e.message);
    commit(CREATE_USER_CONTACT_ERROR, e.message);
    return {};
  }
};

const deleteUserContact = async ({ commit }, { contact }) => {
  try {
    commit(DELETE_USER_CONTACT_REQUEST);
    await Http.delete('/user/contacts/', { device: 'WEB', phones: [contact.phone] });
    commit(DELETE_USER_CONTACT_SUCCESS, contact);
    commit(DELETE_PAYOUT_USER, { user: contact });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('error in deleting contact: ', e);
    commit(DELETE_USER_CONTACT_ERROR, e.message);
  }
};

const saveSelectedContacts = ({ commit }, selected) => {
  try {
    commit(ADD_EVENT_SELECTED_CONTACTS_SUCCESS, selected);
  } catch (e) {
    commit(ADD_EVENT_SELECTED_CONTACTS_ERROR, e);
  }
};

const deleteEventSelectedContacts = ({ commit }, contact = null) => {
  try {
    commit(DELETE_EVENT_SELECTED_CONTACTS_SUCCESS, contact);
  } catch (e) {
    commit(DELETE_EVENT_SELECTED_CONTACTS_ERROR);
  }
};

const deleteAccount = async ({ commit }) => {
  try {
    commit(DELETE_ACCOUNT_REQUEST);
    await Http.delete('/user/me');
    commit(DELETE_ACCOUNT_SUCCESS);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('error in deleting account: ', e);
    commit(DELETE_ACCOUNT_ERROR, e.message);
  }
};

export const actions = {
  [USER_REQUEST]: getUser,
  [UPDATE_USER_REQUEST]: updateUser,
  [CHANGE_PASSWORD_REQUEST]: changePassword,
  [FETCH_USER_CONTACTS_REQUEST]: getContacts,
  [SEARCH_CONTACT_REQUEST]: searchContact,
  [ADD_USER_CONTACT_REQUEST]: addUserContact,
  [CREATE_USER_CONTACT_REQUEST]: createUserContact,
  [DELETE_USER_CONTACT_REQUEST]: deleteUserContact,
  [ADD_EVENT_SELECTED_CONTACTS_REQUEST]: saveSelectedContacts,
  [DELETE_EVENT_SELECTED_CONTACTS_REQUEST]: deleteEventSelectedContacts,
  [DELETE_ACCOUNT_REQUEST]: deleteAccount,
};
